export default __webpack_public_path__ + "static/media/carousel3.cec5f0bf.jpeg";